// Hostname-based portal enforcement.
// If the app is served from a subdomain like `admin.argus.ai` or
// `app.argus.ai` we lock the entire browsing experience to that portal.
// On any other hostname (previews, single domain, localhost) both portals
// coexist and role-based routing takes over.

const HOSTNAME = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";

export const PORTAL = HOSTNAME.startsWith("admin.")
  ? "admin"
  : HOSTNAME.startsWith("app.")
  ? "client"
  : "both";

export const isAdminHost = PORTAL === "admin";
export const isClientHost = PORTAL === "client";
export const isDualHost = PORTAL === "both";
